export default __webpack_public_path__ + "static/media/nft.2f27d8a7.svg";